export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST'
export const FETCH_COMPANIES_SUCCES = 'FETCH_COMPANIES_SUCCES'
export const FETCH_COMPANIES_ERROR = 'FETCH_COMPANIES_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Companies.js